module.exports = __webpack_public_path__ + "img/whatsapp.2bf5f8eb.png";